import React from "react";
import { createApi } from "../../../utils/createApi";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { AxiosError } from "axios";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";

export const handleSendDiceTest = (
  diceAlert: any,
  setSendingDiceTest: Dispatcher<boolean>,
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>,
  setDiceTestFailDialogOpen: Dispatcher<boolean>,
  navigate: NavigateFunction
) => {
  const AxiosUI = createApi(``);

  const postedObject = {
    alert_url: "",
    dice_server: diceAlert.dice_server,
    dice_port: diceAlert.dice_port,
    dice_email: diceAlert.dice_email,
    dice_frames: 5,
    dice_input1: diceAlert.dice_input1,
    dice_text: "",
    ses_cc: "",
  };

  const retryFunction = () => {
    handleSendDiceTest(
      diceAlert,
      setSendingDiceTest,
      setDiceTestSuccessDialogOpen,
      setDiceTestFailDialogOpen,
      navigate
    );
  };

  AxiosUI.post(`/alarm/dice/`, postedObject).then(
    () => {
      setSendingDiceTest(false);
      setDiceTestSuccessDialogOpen(true);
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setSendingDiceTest(false);
        setDiceTestFailDialogOpen(true);
      });
    }
  );
};
